"use client";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsWordcloud from "highcharts/modules/wordcloud";
import { useRouter } from "next13-progressbar";
highchartsWordcloud(Highcharts);

function WordCloudChart({ data, link }) {
  const router = useRouter();

  const options = {
    series: [
      {
        type: "wordcloud",
        data: Object.entries(data).map(([name]) => ({
          name,
          weight: data[name],
        })),
        events: {
          click: function (event) {
            const name = event.point.name;
            router.push(`${link}&f=keyword_str:"${name}"`);
          },
        },
      },
    ],
    title: {
      text: "",
    },
  };
  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
export default WordCloudChart;
